import type { RouteLocationNormalized } from 'vue-router'
import router from '.'
import { getAuthCache } from '@/utils/auth'
import { toOuterLogin } from '@/utils/login'
import { TOKEN_KEY } from '@/enums/cache'
import useMenu from '@/hooks/useMenu'
import { useUserStore } from '@/store/modules/user'
import { DOCUMENT_TITLE } from '@/utils/constants'

const menuStore = useMenu()

const whiteList = ['/login', '/notice/view']

// 根据账号类型获取默认路由
function getDefaultPath() {
  let defaultPath: string | undefined = undefined
  try {
    const userStore = useUserStore()
    defaultPath = userStore.getIsLKUser ? '/report/inventory' : '/index'
  } catch (err) {
    console.log('获取默认路由失败: ', err)
  }
  return defaultPath
}

/** 初始化未完成前的路由缓存 */
const CACHE = {
  to: null as Nullable<RouteLocationNormalized>
}
watch(menuStore.isMenuInited, (bool) => {
  const { to } = CACHE
  if (bool && to) {
    // 判断当前路由是否有权限
    const isAvailable = menuStore.checkRouteAvailable(to)
    const isSilence = to.meta?.silent
    if (!isAvailable && !isSilence) {
      // 无权限时，跳转到有权限的菜单
      const availableRoute = menuStore.getAvailableRoute(getDefaultPath())
      router.push(availableRoute.path).finally(() => {
        // 推送标识：路由完成初始化
        setTimeout(menuStore.changeRouteInited, 0)
      })
    } else {
      menuStore.changeRouteInited()
    }
  }
})
router.beforeEach((to) => {
  const isMenuInited = menuStore.isMenuInited()
  // 未完成菜单初始化，缓存当前的跳转
  if (!isMenuInited) CACHE.to = to
  return true
})
export function routerInit() {
  router.beforeEach((to) => {
    // baidu统计
    try {
      // 用于发送某个指定URL的PV统计请求
      if (window._hmt && to.path) {
        window._hmt.push(['_trackPageview', to.path])
      }
    } catch (e) {
      console.log('百度统计： ', e)
    }

    const hasToken = getAuthCache(TOKEN_KEY)
    if (hasToken) {
      if (to.path === '/login') {
        return { path: '/' }
      }

      return true
    }

    if (whiteList.includes(to.path)) {
      // 重新登录前重置初始化状态
      to.path === '/login' && menuStore.reset()
      return true
    }
    toOuterLogin()
    return false
  })

  router.afterEach((to) => {
    const {
      setTitle = false,
      title = DOCUMENT_TITLE,
      documentTitle = DOCUMENT_TITLE
    } = to.meta ?? {}
    document.title = setTitle ? documentTitle ?? title : DOCUMENT_TITLE
  })
}
